import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostZahlungseingangCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostZahlungseingangCommandService],
  exports: []
})
export class PostZahlungseingangCommandServiceModule { }
